// extracted by mini-css-extract-plugin
export default {"dropdown":"EntityTypeMenu_dropdown__zvENV","recordTypeButton":"EntityTypeMenu_recordTypeButton__-5hVH"};